import urlPluginMessage from './templates/urlPluginMessage';

class UiMutator {
  constructor({ el: observeEl, config }) {
    this.observeEl = observeEl;
    this.config = config;
    this.observer = new MutationObserver(this.#callback.bind(this));
  }

  observe() {
    this.observer.observe(this.observeEl, {
      attributes: false,
      childList: true,
      subtree: true
    });
  }

  disconnect() {
    this.observer.disconnect();
  }

  #callback(mutationList) {
    mutationList.forEach(({ type, addedNodes }) => {
      if (type !== 'childList') return;

      addedNodes.forEach((el) => {
        this.#urlPluginAppendMessage(el);
      });
    });
  }

  #urlPluginAppendMessage(el) {
    if (!(el instanceof Element)) return;
    const targetEl = el.querySelector('.uppy-Url');
    if (!targetEl) return;
    targetEl.appendChild(urlPluginMessage({ maxSize: this.config.maxSize }));
  }
}

export default UiMutator;
